const oysterRouter = [
    {
        path: "list-oyster",
        name: "oyster",
        component: () => import("@/views/admin/oyster"),
        default: true,
        meta: {
            model: "kind",
            // requiresAuth: true,
        },
    },
    {
        path: "list-oyster/add",
        name: "addOyster",
        component: () => import("@/views/admin/oyster/function"),
        default: true,
        meta: {
            model: "kind",
            // requiresAuth: true,
        },
    },
    {
        path: "list-oyster/edit/:id",
        name: "editOyster",
        component: () => import("@/views/admin/oyster/function"),
        default: true,
        meta: {
            model: "kind",
            // requiresAuth: true,
        },
    },
];
export default oysterRouter;